export default __webpack_public_path__ + "static/media/bg-190hjnj.dd2a1e80.png";